import {
    Badge,
    Box,
    Flex,
    Group,
    Progress,
    Stack,
    Text,
    Tooltip,
} from '@mantine/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

const ConversationCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <NavLink
                to={`/engagement/sms/conversations/${rowData.conversationId}`}>
                <Text ta={'center'}>{rowData.conversationId}</Text>
            </NavLink>
        </Box>
    );
};

const ConversationColumn = () => ({
    accessorKey: 'conversationId',
    header: 'Conversation',
    minSize: 40,
    maxSize: 60,
    Cell: ({ cell }) => <ConversationCell cell={cell} />,
});
export default ConversationColumn;
